<script setup lang="ts">
import { BoxesIcon } from 'lucide-vue-next'

const { data: recyclerWelcomeScreenPendingResponse, isPending } = useRecyclerWelcomeScreenPendingResponse()

const { t } = useI18n()
const router = useRouter()

const handleCardClick = (action: string) => {
  router.push(action)
}
</script>

<template>
  <ActionCard
    :icon="BoxesIcon"
    :title="t('global.recycler_welcome_screen_pending_response_card_title', { count: recyclerWelcomeScreenPendingResponse?.count })"
    button-action="/my-materials"
    :button-label="t('global.see_all')"
    :is-loading="isPending"
    :is-visible="!!recyclerWelcomeScreenPendingResponse?.count"
    @click="handleCardClick"
  />
</template>
